import React, { useContext, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { confirmSignUp, resendSignUpCode } from 'aws-amplify/auth'; // AWS Amplify functions
import { useToast } from '../context/ToastContext';
import logo from '../assets/logo.png';
import { UserRoleContext } from '../context/UserRoleContext';
import { ROUTES } from '../constants/routes';


const RegistrationSuccessComponent: React.FC = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { userRole } = useContext(UserRoleContext);

  const [confirmationCode, setConfirmationCode] = useState('');
  const [error, setError] = useState('');
  const [resendLoading, setResendLoading] = useState(false); // Loading state for resend button
  const [resendError, setResendError] = useState(''); // Error state for resend


  return (
    <div style={{ alignContent: 'center', justifyContent: 'center', display: 'flex', width: '100%', height: '600px'}}>
      <div className="card" style={{ maxWidth: '600px', backgroundColor: 'white', justifyContent: 'center', alignItems: 'center', textAlign: 'center', maxHeight: '400px', marginTop: '100px'}}>
          <img src={logo} alt="Cyne Up" style={{ maxWidth: '50%' }} />
        <h1 style={{marginTop: '0px'}}>You Have Successfully Cyned Up!</h1>
        <p>Thank you for using the fastest Cyber Sign Up!</p>
        <h4>You may now close this tab.</h4>
        <p>To host your own event or learn more about Cyne Up, visit <a target="_blank" href="https://www.cyneup.com">CyneUp.com</a></p>
        <br/>
        { userRole && <div className='buttonsRow'>
        <button onClick={() => {navigate(ROUTES.CYNE_UP)}}>Add Another Registrant</button>
        <button onClick={() => {navigate(ROUTES.HOME)}}>Return To Home</button>
        </div>}
      </div>
    </div>
  );
};

export default RegistrationSuccessComponent;
